import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './addons/Color.css';
import './addons/Fonts.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
